import { createContext, useContext, useState } from "react";
interface ConfigurationContextInterface {
  network: number;
  setNetwork: (value: number) => void;
  resolution: string;
  setResolution: (value: string) => void;
}
const ConfigurationContext = createContext({} as ConfigurationContextInterface);
export const ConfigurationProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [network, setNetwork] = useState(0);
  const [resolution, setResolution] = useState('1D');
  return <ConfigurationContext.Provider value={{
    network,
    setNetwork,
    resolution,
    setResolution
  }} data-sentry-element="unknown" data-sentry-component="ConfigurationProvider" data-sentry-source-file="ConfigurationProvider.tsx">
            {children}
        </ConfigurationContext.Provider>;
};
export const useConfiguration = () => {
  const configurationValues = useContext(ConfigurationContext);
  return configurationValues;
};